import React from 'react';
import { TypedMemo } from '../../../common/types';
import { ErrorAlert } from '../../../common/views/ErrorAlert/ErrorAlert';
import { CatalogReleaseEvent } from '../../../../redux/api/fymAPI.types';
import { useReleaseEvents } from './useReleaseEvents';
import { ReleaseLinkedCard } from './ReleaseLinkedCard';
import { ReleaseAskCard } from './ReleaseAskCard';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the release cards; each part uses its own slice of it */
import styles from './ReleaseCards.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReleaseEventCardsProps {
  accountId: number;
  /** "See the release": the screen opens the row of the event. */
  onSeeRelease: (event: CatalogReleaseEvent) => void;
}

/**
 * The release-day cards on top of the catalog (design g3, D21). They show until the artist closes
 * them. Nothing shows when no event is open.
 */
const ReleaseEventCardsComponent: React.FC<ReleaseEventCardsProps> = ({ accountId, onSeeRelease }) => {
  const { events, dismiss, link, isBusy, error } = useReleaseEvents({ accountId });

  if (events.length === 0 && error === undefined) {
    return null;
  }

  return (
    <div className={styles.stack}>
      {error !== undefined && <ErrorAlert error={error} />}
      {events.map((event) =>
        event.kind === 'linked' ? (
          <ReleaseLinkedCard key={event.id} event={event} disabled={isBusy} onSee={onSeeRelease} onDismiss={dismiss} />
        ) : (
          <ReleaseAskCard key={event.id} event={event} disabled={isBusy} onLink={link} onDismiss={dismiss} />
        )
      )}
    </div>
  );
};

export const ReleaseEventCards = TypedMemo(ReleaseEventCardsComponent);
